<template>
    <el-popover
        :placement="position"
        :width="width"
        trigger="hover"
        v-bind="$attrs"
    >

        <template v-if="$slots.tip">
            <slot name="tip"></slot>
        </template>

        <template v-else>{{tip}}</template>

        <template #reference>
            <span>{{label}}<i v-if="showIcon" class="icon-tip el-icon-info"></i><template v-if="colon">：</template></span>
        </template>
    </el-popover>

</template>

<script>
export default {
    name: 'TipLabel',

    props: {
        // 标题
        label: {
            type: String
        },
        // 提示 {string | slot}
        tip: {
            type: String
        },
        // 是否显示提示图标
        showIcon: {
            type: Boolean,
            default: true
        },
        // 宽度 {string | number}
        width: {
            default: 300
        },
        position: {
            type: String,
            default: 'top'
        },
        colon: {
            type: Boolean,
            default: false
        }
    },
}
</script>

<style lang="scss">

.icon-tip {
    padding-left: 3px;
    font-size: 12px;
    vertical-align: middle;
    color: #c2c3c5;
}
</style>
